import logo from './images/tb-logo.png';
import { Outlet } from 'react-router';
import React from "react";
import muiTheme from './theme/muiTheme';
import * as theme from './theme';
import './theme/index.css';
import { ThemeProvider } from '@mui/material';

function PublicLayout() {

  return (
    <ThemeProvider theme={muiTheme}>
      <div className="app" style={{ marginTop: 0, marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
        <div style={{ ...theme.Container.basic, ...theme.Container.centeredViewport, color: theme.Colors.White, width: '100%' }}>
          <Outlet />
          <div style={{ ...theme.Container.flexCenter }}>
            <a href="https://trubalancebioenergetics.com"><img src={logo} alt="TruBalance Bioenergetics" style={{ height: 140 }} /></a>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default PublicLayout;
